export default __webpack_public_path__ + "static/media/small-game@3x.9b94d0cd.jpg";